import { withStyles } from '@material-ui/core';
import Tabs from './Tabs.container';
import styles from './Tabs.styles';

export default withStyles(styles)(Tabs);
